import { BaridAgentStatus } from './barid-contracts';
import { isBaridAgentOutdated } from './barid-version.util';

export type BaridConnectivityLevel = 'ok' | 'warn' | 'offline' | 'loading';

export interface BaridConnectivityState {
  level: BaridConnectivityLevel;
  /** Texto curto do tooltip/leitor de tela. */
  label: string;
  icon: string;
}

/**
 * Estado do indicador de conectividade do agente (barra superior). `null` = nao mostrar:
 * o agente nunca respondeu neste computador (Barid nao instalado: nenhum icone permanente
 * para quem nao usa). Se ele ja respondeu e deixou de responder, mostra "parado".
 */
export function baridConnectivityState(status: BaridAgentStatus | null, everSeen: boolean): BaridConnectivityState | null {
  if (!status) {
    return everSeen
      ? { level: 'offline', label: 'Barid parado neste computador. Impressões ficam na fila do Wazir até ele voltar.', icon: 'print_disabled' }
      : null;
  }
  if (status.configLoading) {
    return { level: 'loading', label: 'Barid carregando a configuração deste computador…', icon: 'sync' };
  }
  if (!status.online) {
    return { level: 'offline', label: 'Barid parado neste computador. Impressões ficam na fila do Wazir até ele voltar.', icon: 'print_disabled' };
  }
  if (isBaridAgentOutdated(status.apiVersion)) {
    return { level: 'warn', label: 'Barid em execução, mas desatualizado. Instale a versão atual.', icon: 'system_update' };
  }
  if (!status.paired) {
    return { level: 'warn', label: 'Barid em execução, mas este computador não está pareado ao Wazir.', icon: 'link_off' };
  }
  return { level: 'ok', label: `Barid online e pareado (versão ${status.agentVersion}).`, icon: 'print' };
}
